import React, { useState, useEffect } from 'react';
import { adService } from '../../services/api';

function AdsManagement() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ title: '', content: '', link: '', position: 'home_banner', start_date: '', end_date: '' });

  useEffect(() => {
    loadAds();
  }, []);

  const loadAds = async () => {
    try {
      const data = await adService.index();
      setAds(data.data || data || []);
    } catch (error) {
      console.error('Error loading ads:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await adService.store(formData);
      setShowModal(false);
      setFormData({ title: '', content: '', link: '', position: 'home_banner', start_date: '', end_date: '' });
      loadAds();
    } catch (error) {
      console.error('Error saving ad:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this ad?')) {
      try {
        await adService.destroy(id);
        loadAds();
      } catch (error) {
        console.error('Error deleting ad:', error);
      }
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Advertisements</h2>
        <button onClick={() => setShowModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Add Ad</button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {ads.map((ad) => (
              <tr key={ad.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{ad.title}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{ad.position}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{ad.start_date ? new Date(ad.start_date).toLocaleDateString() : '-'}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{ad.end_date ? new Date(ad.end_date).toLocaleDateString() : '-'}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button onClick={() => handleDelete(ad.id)} className="text-red-600 hover:text-red-900">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {ads.length === 0 && <div className="text-center py-8 text-gray-500">No ads found</div>}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg">
            <h3 className="text-lg font-semibold mb-4">Add Advertisement</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input required placeholder="Title" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="w-full border rounded p-2" />
              <textarea placeholder="Content" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} className="w-full border rounded p-2" />
              <input placeholder="Link URL" value={formData.link} onChange={(e) => setFormData({ ...formData, link: e.target.value })} className="w-full border rounded p-2" />
              <select value={formData.position} onChange={(e) => setFormData({ ...formData, position: e.target.value })} className="w-full border rounded p-2">
                <option value="home_banner">Home Banner</option>
                <option value="sidebar">Sidebar</option>
                <option value="footer">Footer</option>
              </select>
              <input type="date" placeholder="Start date" value={formData.start_date} onChange={(e) => setFormData({ ...formData, start_date: e.target.value })} className="w-full border rounded p-2" />
              <input type="date" placeholder="End date" value={formData.end_date} onChange={(e) => setFormData({ ...formData, end_date: e.target.value })} className="w-full border rounded p-2" />
              <div className="flex justify-end gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdsManagement;
